module.exports = __webpack_public_path__ + "static/media/creating.d14fc89f.svg";